export { default, type ButtonDefinition } from './Dialog';
